module.exports = __webpack_public_path__ + "media/promo/advent/images/main-bgm-ddaefdcbf224af44991e7f3dafaaf194.jpg";